import { render } from "./activation.vue?vue&type=template&id=3331709c"
import script from "./activation.vue?vue&type=script&lang=js"
export * from "./activation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__